<template>
    <nav class="nav-container container">
        <ul>
            <li>
                <a href="#home" :class="{'active': currentSectionPositionIndex === 0}">Home</a>
            </li>
            <li>
                <a href="#services" :class="{'active': currentSectionPositionIndex === 1}">Services</a>
            </li>
            <li>
                <a href="#about" :class="{'active': currentSectionPositionIndex === 2}">About</a>
            </li>
        </ul>
    </nav>
</template>

<script>
    const SmoothScroll = require('smooth-scroll');
    export default {
        props: {
            currentSectionPositionIndex: Number
        },
        mounted() {
            this.initializeSmoothScrolling();
        },
        methods: {
            initializeSmoothScrolling() {
                new SmoothScroll('a[href*="#"]', {
                    speed: 500,
                    easing: 'easeInOutQuint'
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import './src/assets/styles/variables/variables';

    .nav-container {
        bottom: 0;
        position: fixed;
        height: 100vh;
        width: 100%;
        max-width: $page-max-width;
        z-index: 300;

        @media all and (max-width: 800px) {
            height: 50px;
            width: 100%;
            margin: auto;
            left: 0;
            right: 0;
            z-index: 600;
            background: rgba(black, 1);
            bottom: 0 !important;

            ul {
                transform: none;
                left: 0;
                right: 0;
                top: 33.333333%;
                bottom: 0;
            }
        }
    }

    ul {
        @media all and (max-width: 1500px) {
            left: 80%;
        }
        position: absolute;
        right: 0;
        top: 50%;
        left: 90%;
        display: flex;
        flex-direction: row;
        transform: rotate(90deg);
        justify-content: center;
        padding: 0;
        margin: 0;

        li {

            a {
                z-index: 500;
                cursor: pointer;
                opacity: .4;

                &.active {
                    opacity: .9;
                }

                &:hover {
                    opacity: .9;
                }

                padding: 20px !important;
                font-family: $font-family-title !important;
                text-transform: uppercase;
                font-size: 1em;
                text-decoration: none;
            }

            list-style: none;
        }
    }
</style>
